import axios from 'axios'
import { restEndPoint, apiEndPoint } from './constants'
const email = 'test@test.com'
const pass = 'test'
const auth = new Buffer.from(email + ':' + pass).toString('base64')
const headers = {
  Authorization: 'Basic ' + auth,
  'Content-Type': 'application/json',
}
export default {
  // The install method will be called with the Vue constructor as         
  // the first argument, along with possible options
  install (Vue, options) {
     // Add or modify global methods or properties.
      Vue.prototype.$restBidders = async (filters, page) =>  {
        try {
          const url = `${restEndPoint}/bidders`
          const order_by = [{
            "field": "rgstDt",
            "direction": "desc"
          }]
          const params = {
            page: page,
            q: JSON.stringify({
              filters: filters,
              order_by: order_by
            })
          }
          const res = await axios.get(url, { params: params, headers: headers })
          return res.data
        } catch(err) {
          console.log(err)
        } 
      }
      Vue.prototype.$queryApis = async (bizno) => {
        try {
          const url = `${apiEndPoint}/apis/queryBidder/${bizno}`
          const res = await axios.get(url)
          return res.data
        } catch (err) {
          console.log(err)
        }
      }

  }
}
